import { createFileRoute } from "@tanstack/react-router"

import { SettingsAccountPage } from "@/pages/settings/account"

// Splat so Clerk can own its own sub-paths under /settings/account/profile (currently `/security`).
// Clerk requires the component to render on the mount path and every path below it.
export const Route = createFileRoute("/_authenticated/settings/account/profile/$")({
  component: SettingsAccountPage,
})
